import * as Sentry from "@sentry/react";
import { IS_MS_LOGOUT_ENABLED, MS_LOGOUT_URL } from "common/config";
import PushNotificationService from "services/PushNotificationService";
import { hardRedirect } from "./navigation";
import { endOrySession, isOidcSession } from "./ory";
import { beginLogout, clearClientState, endLogout } from "./session";

export const LOGGED_OUT_PATH = "/logged-out";

const PUSH_UNSUBSCRIBE_TIMEOUT_MS = 3000;

const withTimeout = (promise: Promise<unknown>, ms: number): Promise<void> =>
  new Promise<void>(resolve => {
    const timer = setTimeout(resolve, ms);

    promise
      .catch(() => undefined)
      .finally(() => {
        clearTimeout(timer);
        resolve();
      });
  });

const buildMicrosoftLogoutUrl = (): string => {
  const url = new URL(MS_LOGOUT_URL);

  url.searchParams.set(
    "post_logout_redirect_uri",
    `${window.location.origin}${LOGGED_OUT_PATH}`
  );

  return url.toString();
};

export const logoutUser = async (): Promise<void> => {
  if (!beginLogout()) {
    return;
  }

  try {
    const isOidc = await isOidcSession();

    await withTimeout(
      PushNotificationService.unsubscribePushNotification(),
      PUSH_UNSUBSCRIBE_TIMEOUT_MS
    );

    await endOrySession();

    const destination =
      IS_MS_LOGOUT_ENABLED && isOidc
        ? buildMicrosoftLogoutUrl()
        : LOGGED_OUT_PATH;

    await clearClientState();

    hardRedirect(destination);
  } catch (error) {
    Sentry.captureException(error, {
      tags: { section: "auth", step: "logout" },
    });

    endLogout();

    throw error;
  }
};
